import { useState } from 'react';
import type { Cita } from '../../api/ops/citas';
import { useAvisoBreve } from '../../componentes/avisoBreve';
import { Campo } from '../../componentes/Campo';
import { Ventana } from '../../componentes/Ventana';
import { dinero } from '../../logica/dinero';
import type { ContextoAgenda } from './contexto';
import { primerNombre, textoDeError } from './logica';

/**
 * Ventana «¿… no vino?» (G15, G322): la marca siempre una persona, desde el inicio más el margen (`can_mark_no_show_from`).
 * La nota es opcional y solo la ve el equipo. Sin cobro (`not_required`), el texto del diseño; con política, el importe que
 * se cobraría (`no_show_charge_amount`, lo calcula la API, G842; el panel no lo calcula).
 */
export function VentanaNoVino({ ctx, cita, onCerrar, onHecho }: { ctx: ContextoAgenda; cita: Cita | null; onCerrar: () => void; onHecho: (c: Cita) => void }) {
    const [nota, setNota] = useState('');
    const [ocupado, setOcupado] = useState(false);
    const avisar = useAvisoBreve();
    const nombre = cita === null ? '' : ctx.nombreDe(cita);
    const texto =
        cita === null
            ? ''
            : cita.payment_status === 'not_required'
              ? `Queda como no presentado y se libera el resto de su hueco${cita.status === 'pending_completion' ? '' : ' para otra cita'}. No se le cobra nada.`
              : (cita.no_show_charge_amount?.amount ?? 0) > 0
                ? `Queda como no presentado. Le avisamos y se le cobran ${dinero(cita.no_show_charge_amount)} en la tarjeta que guardó.`
                : 'Queda como no presentado. No se le cobra nada más.';
    return (
        <Ventana
            abierta={cita !== null}
            titulo={`¿${primerNombre(nombre)} no vino?`}
            texto={texto}
            cancelar="Volver"
            accion={ctx.movil ? 'No vino' : 'Marcar que no vino'}
            accionIcono="user-x"
            ocupado={ocupado}
            ocupadoTexto="Marcando…"
            movil={ctx.movil}
            onCerrar={() => {
                if (!ocupado) {
                    setNota('');
                    onCerrar();
                }
            }}
            onAccion={() => {
                if (cita === null) {
                    return;
                }
                setOcupado(true);
                ctx.ops
                    .markAppointmentNoShow(ctx.negocio, cita.id, nota)
                    .then((c) => {
                        setNota('');
                        onHecho(c);
                    })
                    .catch((e: unknown) => {
                        avisar({ tipo: 'error', texto: textoDeError(e) });
                    })
                    .finally(() => {
                        setOcupado(false);
                    });
            }}
        >
            <Campo etiqueta="Nota" valor={nota} onChange={setNota} ayuda="Opcional. Solo la ve tu equipo." max={500} mayusculas="sentences" />
        </Ventana>
    );
}
